import { Component, Input } from '@angular/core';
import { PRODUCT_TYPE_SHAPES } from '../../constants/common.constants';

@Component({
  standalone: false,
  selector: 'ui-shape-icon',
  templateUrl: './ui-shape-icon.component.html',
  styleUrls: ['./ui-shape-icon.component.scss']
})
export class UiShapeIconComponent {

  @Input() keyword: string;
  @Input() externalClass: string;

  PRODUCT_TYPE_SHAPES = PRODUCT_TYPE_SHAPES;
}
